var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var buttonElement = require('../components/button');
var formGroup = require('../components/formGroup');
var ToggleSwitch = require('../components/toggleSwitch');
var fieldnetTree = require('../network/components/fieldnetTree');
var loaders = require('../layout/components/loaders');
var serviceTaxonomy = require('../service/serviceTaxonomy');
var serviceClassSelect = require('../service/components/serviceClassSelect');
var serviceModel = require('../service/models/service');
var equipmentModel = require('./models/equipment');
var customEquipmentModel = require('../../../../models/equipment/customEquipment');
var pointTd = require('../data/components/pointTd');
var Sortable = require('../libs/draggableWithDragscroll');
var STATIC_SVG_UID_PROP = '__staticSvgUid';
var { evaluateFormula } = require('./libs/formulaSandbox');


function unwrapMithrilComponent (maybeModule) {
  var current = maybeModule;
  var visited = [];

  while (current && typeof current === 'object' && 'default' in current && visited.indexOf(current) === -1) {
    visited.push(current);
    current = current.default;
  }

  if (typeof current === 'function') return current;
  if (current && typeof current.view === 'function') return current;
  return null;
}

function getPointTd () {
  if (!pointTdModule) {
    pointTdModule = require('../data/components/pointTd');
    pointTdResolved = unwrapMithrilComponent(pointTdModule);
  }
  return pointTdResolved;
}



var editCustomEquipmentModal = Object.assign(Object.create(Model), {});
var DEFAULT_PORT_POSITION = 'right';
var DEFAULT_PORT_TYPE = 'output';
var DEFAULT_PORT_DIRECTION = 'right';
var DEFAULT_PORT_CONNECTOR = 'head';

function defineStaticSvgInternalId(item, uid) {
  if (!item || typeof item !== 'object') return;
  Object.defineProperty(item, STATIC_SVG_UID_PROP, {
    value: uid,
    enumerable: false,
    writable: false,
    configurable: false
  });
}

function ensureStaticSvgInternalId(item, providedUid) {
  if (!item || typeof item !== 'object') return null;

  var existing = item[STATIC_SVG_UID_PROP];
  if (Number.isFinite(existing)) {
    if (!Number.isFinite(editCustomEquipmentModal.nextStaticSvgUid) || existing >= editCustomEquipmentModal.nextStaticSvgUid) {
      editCustomEquipmentModal.nextStaticSvgUid = existing + 1;
    }
    return existing;
  }

  if (!Number.isFinite(editCustomEquipmentModal.nextStaticSvgUid)) {
    editCustomEquipmentModal.nextStaticSvgUid = 1;
  }

  var uid = Number.isFinite(providedUid) ? providedUid : editCustomEquipmentModal.nextStaticSvgUid++;
  defineStaticSvgInternalId(item, uid);

  if (uid >= editCustomEquipmentModal.nextStaticSvgUid) {
    editCustomEquipmentModal.nextStaticSvgUid = uid + 1;
  }

  return uid;
}

function getStaticSvgInternalId(item) {
  if (!item || typeof item !== 'object') return null;
  var value = item[STATIC_SVG_UID_PROP];
  return Number.isFinite(value) ? value : null;
}

function sanitizeStaticSvgCollection(staticSvgs) {
  editCustomEquipmentModal.nextStaticSvgUid = 1;

  var sanitized = (Array.isArray(staticSvgs) ? staticSvgs : [])
    .slice()
    .sort(function (a, b) {
      return (Number(a && a.key) || 0) - (Number(b && b.key) || 0);
    })
    .map(function (item, index) {
      var sanitizedItem = {
        key: index + 1,
        label: typeof (item && item.label) === 'string' ? item.label : '',
        svg: typeof (item && item.svg) === 'string' ? item.svg : '',
        svgConverted: typeof (item && item.svgConverted) === 'string' ? item.svgConverted : ''
      };
      ensureStaticSvgInternalId(sanitizedItem);
      return sanitizedItem;
    });

  editCustomEquipmentModal.nextStaticSvgKey = sanitized.length + 1;

  return sanitized;
}

function resequenceStaticSvgKeys(staticSvgs) {
  if (!Array.isArray(staticSvgs)) return;

  staticSvgs.forEach(function (entry, index) {
    entry.key = index + 1;
  });

  editCustomEquipmentModal.nextStaticSvgKey = staticSvgs.length + 1;
}

function normalizeLinkedPointRid(value) {
  if (value === undefined || value === null) return null;
  if (typeof value === 'object' && value['@rid']) return normalizeLinkedPointRid(value['@rid']);

  var rid = String(value).trim();
  if (!rid || rid === 'null' || rid === 'undefined' || rid === '[object Object]') return null;
  return rid.charAt(0) === '#' ? rid : '#' + rid;
}

function getLinkedPointRid(pointRecord) {
  if (!pointRecord) return null;
  if (typeof pointRecord === 'string') return normalizeLinkedPointRid(pointRecord);
  return normalizeLinkedPointRid(pointRecord.rid || pointRecord['@rid']);
}

function getLinkedPointId(pointRecord, fallbackId) {
  if (!pointRecord || typeof pointRecord !== 'object') return fallbackId || '';
  return pointRecord.id || pointRecord.name || fallbackId || '';
}

function createLinkedPointColumn(pointRecord, pointData) {
  var rid = getLinkedPointRid(pointRecord);
  if (!rid) return null;

  return {
    in: {
      '@rid': rid,
      id: getLinkedPointId(pointRecord),
      path: Array.isArray(pointData && pointData.path) ? pointData.path : []
    }
  };
}

function createMissingLinkedPointColumn(pointRecord) {
  var column = createLinkedPointColumn(pointRecord, null);
  if (!column) return null;

  column.in.missingResource = true;
  return column;
}

function normalizeLinkedPointColumns(columns) {
  return (Array.isArray(columns) ? columns : [])
    .map(function (column) {
      if (!column || typeof column !== 'object') return null;
      if (!column.in || typeof column.in !== 'object') return null;

      var rid = normalizeLinkedPointRid(column.in['@rid'] || column.in.rid);
      if (!rid) return null;

      column.in['@rid'] = rid;
      if (!Array.isArray(column.in.path)) column.in.path = [];
      return column;
    })
    .filter(Boolean);
}

function setCurrentLinkedPointColumns(columns) {
  var record = editCustomEquipmentModal.equipmentRecord && editCustomEquipmentModal.equipmentRecord();
  if (!record) return [];

  record.columns = normalizeLinkedPointColumns(columns);
  return record.columns;
}

function getCurrentLinkedPointColumns() {
  var record = editCustomEquipmentModal.equipmentRecord && editCustomEquipmentModal.equipmentRecord();
  return setCurrentLinkedPointColumns(record && record.columns);
}

function buildPointsLinkedPayload(columns) {
  return normalizeLinkedPointColumns(columns).map(function (column) {
    return {
      rid: column.in['@rid'],
      id: column.in.id
    };
  });
}

function getMissingLinkedPointColumns(columns) {
  return normalizeLinkedPointColumns(columns).filter(function (column) {
    return !!(column.in && column.in.missingResource);
  });
}

function formatLinkedPointLabel(column) {
  var point = column && column.in ? column.in : {};
  var rid = point['@rid'] || 'unknown RID';
  return point.id ? point.id + ' (' + rid + ')' : rid;
}

function getFormulaPointsForColumns(columns, errors) {
  var normalizedColumns = normalizeLinkedPointColumns(columns);
  var missingColumns = getMissingLinkedPointColumns(normalizedColumns);

  if (missingColumns.length) {
    errors.push(
      'Linked point ' +
      missingColumns.map(formatLinkedPointLabel).join(', ') +
      ' no longer has a resource. Remove it or select another point before testing the formula.'
    );
    return null;
  }

  return normalizedColumns.map(function (column) {
    return column.in;
  });
}

async function loadLinkedPointColumn(pointRecord) {
  var pointRid = getLinkedPointRid(pointRecord);
  if (!pointRid) return null;

  try {
    const pointData = await loaders.requestWithLoader({
      loader: 'main',
      url: `/api/v1/point/${pointRid.slice(1)}/resource`,
      method: 'GET',
    });

    if (!pointData) {
      console.error(`Error fetching point data for ${pointRid}`);
      return createMissingLinkedPointColumn(pointRecord);
    }

    return createLinkedPointColumn(pointRecord, pointData);
  } catch (error) {
    console.error(`Error fetching point data for ${pointRid}`, error);
    return createMissingLinkedPointColumn(pointRecord);
  }
}


modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

editCustomEquipmentModal.editDialogue = async function (record, options) {
  if (record.class) {
    record['@class'] = record.class;
  }
  if (record.key) {
    record['@rid'] = record.key;
  }

  if (!record.data) {
    record.data = {};
  }

  const sanitizedStaticSvgs = sanitizeStaticSvgCollection(Array.isArray(record.staticSvgs) ? record.staticSvgs : []);
  record.staticSvgs = sanitizedStaticSvgs;
  editCustomEquipmentModal.originalStaticSvgs = JSON.stringify(sanitizedStaticSvgs);

  if (typeof record.geojson === 'object') { record.geojson = JSON.stringify(record.geojson); }

  editCustomEquipmentModal.originalSvg = `${record.svg}`
  editCustomEquipmentModal.originalSvgBackground = `${record.svgBackground}`
  editCustomEquipmentModal.originalSvgForeground = `${record.svgForeground}`
  editCustomEquipmentModal.originalMapSvg = `${record.mapSvg}`
  editCustomEquipmentModal.equipmentRecord = prop(record);
  editCustomEquipmentModal.equipmentRecordClass = prop(record['@class']);
  editCustomEquipmentModal.equipmentRecordPortValues = record.ports ? Object.values(record.ports) : [];
  if (!editCustomEquipmentModal.equipmentRecord().data) editCustomEquipmentModal.equipmentRecord().data = {};
  editCustomEquipmentModal.fields = Object.fromEntries(
    Object.entries(customEquipmentModel.fields)
      .filter(([key, value]) => !value.hidden)
  );

  const pointRecords = Array.isArray(editCustomEquipmentModal.equipmentRecord().pointsLinked)
    ? editCustomEquipmentModal.equipmentRecord().pointsLinked
    : [];

  const columns = await Promise.all(
    pointRecords.map(loadLinkedPointColumn)
  );

  editCustomEquipmentModal.equipmentRecord().columns = normalizeLinkedPointColumns(columns);


  // Adding the new Point 
  editCustomEquipmentModal.showFielnetTree = prop(false);
  editCustomEquipmentModal.newPointToAdd = prop(null);

  editCustomEquipmentModal.errors = [];

  editCustomEquipmentModal.propertiesSectionOpen = prop(true);
  editCustomEquipmentModal.svgSectionOpen = prop(false);
  editCustomEquipmentModal.mapSectionOpen = prop(false);
  editCustomEquipmentModal.diagramSectionOpen = prop(false);
  editCustomEquipmentModal.portsSectionOpen = prop(false);
  serviceModel.getClassTree().then(function () {
    m.redraw();
  }).catch(function () {
    return null;
  });


  var submit = async function () {
    editCustomEquipmentModal.errors = [];
    const nameMaxLength = customEquipmentModel.fields.name.validators.length.maximum;
    if (
      typeof editCustomEquipmentModal.equipmentRecord().name === 'string' &&
      editCustomEquipmentModal.equipmentRecord().name.length > nameMaxLength
    ) {
      editCustomEquipmentModal.errors.push('Name must be ' + nameMaxLength + ' characters or fewer.');
      return;
    }
    // Check if a function is defined but there are no points
    const linkedPointColumns = getCurrentLinkedPointColumns();
    if (editCustomEquipmentModal.equipmentRecord().formula?.trim().length > 0 && linkedPointColumns.length === 0) {
      editCustomEquipmentModal.errors.push("You must define at least one point before setting a function.");
      return;
    }

    // Test from formula
    if (editCustomEquipmentModal.equipmentRecord()?.formula?.trim().length > 0 && !editCustomEquipmentModal.testFormula()) {
      console.error("Formula test failed. Stopping execution.");
      return;
    }

    if (editCustomEquipmentModal.equipmentRecord().animationType == 'rotate' && editCustomEquipmentModal.equipmentRecord()?.rotatorDashArray) {
      const isValid = /^\d+,\d+$/.test(editCustomEquipmentModal.equipmentRecord().rotatorDashArray);
      if (!isValid) {
        editCustomEquipmentModal.errors.push('Rotator dash-array invalid. Please use the format "<number>,<number>"');
        return;
      }
    }

    if (editCustomEquipmentModal.equipmentRecord().animationType === 'staticSvg') {
      const staticSvgs = editCustomEquipmentModal.equipmentRecord().staticSvgs || [];
      if (staticSvgs.length === 0) {
        editCustomEquipmentModal.errors.push('Add at least one Static SVG before saving this configuration.');
        return;
      }
      const formula = editCustomEquipmentModal.equipmentRecord().formula;
      if (!formula || !formula.trim()) {
        editCustomEquipmentModal.errors.push('Provide a formula to determine which Static SVG to display.');
        return;
      }
    }

    if (editCustomEquipmentModal.equipmentRecord().animationType === 'damper') {
      const formula = editCustomEquipmentModal.equipmentRecord().formula;
      if (!formula || !formula.trim()) {
        editCustomEquipmentModal.errors.push('Provide a formula to control the damper animation.');
        return;
      }
    }

    // Update linked points
    editCustomEquipmentModal.equipmentRecord().pointsLinked =
      buildPointsLinkedPayload(linkedPointColumns)

    let ports = editCustomEquipmentModal.equipmentRecordPortValues.reduce((acc, item, index) => {
      acc[index] = item;
      return acc;
    }, {});

    let uniquePortNames = arePortsNamesValid(ports, editCustomEquipmentModal.errors);

    let fields = {};
    Object.entries(editCustomEquipmentModal.fields).forEach(([field, value]) => {
      if (
        (
          editCustomEquipmentModal.equipmentRecord()[field] ||
          editCustomEquipmentModal.equipmentRecord()[field] == ''
        ) &&
        field != 'svg' &&
        field != 'svgBackground' &&
        field != 'svgForeground' &&
        field != 'mapSvg' &&
        field != 'staticSvgs'
      ) {
        fields[field] = editCustomEquipmentModal.equipmentRecord()[field]
      }
    });

    if (uniquePortNames) {
      if (Object.keys(fields).length > 0) {
        await loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/equipment/' + record['@rid'].slice(1),
          method: 'PUT',
          body: { ...fields }
        })
      }


      await loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/customequipment/' + record['@rid'].slice(1) + '/ports',
        method: 'PUT',
        body: { ports }
      })

      const svgUpdates = [
        { field: 'svg', current: editCustomEquipmentModal.equipmentRecord().svg, original: editCustomEquipmentModal.originalSvg },
        { field: 'svgBackground', current: editCustomEquipmentModal.equipmentRecord().svgBackground, original: editCustomEquipmentModal.originalSvgBackground },
        { field: 'svgForeground', current: editCustomEquipmentModal.equipmentRecord().svgForeground, original: editCustomEquipmentModal.originalSvgForeground },
        { field: 'mapSvg', current: editCustomEquipmentModal.equipmentRecord().mapSvg, original: editCustomEquipmentModal.originalMapSvg }
      ];
      
      for (const { field, current, original } of svgUpdates) {
        if (`${current}` != original) {
          await loaders.requestWithLoader({
            loader: 'main',
            url: `/api/v1/customequipment/${record['@rid'].slice(1)}/svg`,
            method: 'PUT',
            body: { svg: current, field }
          });
        }
      }

      const currentStaticSvgsSerialized = JSON.stringify(editCustomEquipmentModal.equipmentRecord().staticSvgs || []);
      if (currentStaticSvgsSerialized !== editCustomEquipmentModal.originalStaticSvgs) {
        const response = await loaders.requestWithLoader({
          loader: 'main',
          url: `/api/v1/customequipment/${record['@rid'].slice(1)}/static-svgs`,
          method: 'PUT',
          body: { staticSvgs: editCustomEquipmentModal.equipmentRecord().staticSvgs || [] }
        });
        const sanitizedStaticSvgs = sanitizeStaticSvgCollection(
          (response && response.staticSvgs) || editCustomEquipmentModal.equipmentRecord().staticSvgs || []
        );
        editCustomEquipmentModal.equipmentRecord().staticSvgs = sanitizedStaticSvgs;
        editCustomEquipmentModal.originalStaticSvgs = JSON.stringify(sanitizedStaticSvgs);
      }

      if (record['@class'] != editCustomEquipmentModal.equipmentRecordClass()) {
        let response = await loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/customequipment/' + record['@rid'].slice(1) + '/class',
          method: 'PUT',
          body: { class: editCustomEquipmentModal.equipmentRecordClass() }
        });
      
        await m.route.set(`/equipment/${response.newClass.toLowerCase()}/${response.newRid.slice(1)}`);
      } else {
        if (options?.submitCallback) options.submitCallback();
      }
      
      key.unbind('enter');
      modal.vm.close();
    }
  };

  editCustomEquipmentModal.testFormula = function () {
    // Clear previous errors
    editCustomEquipmentModal.errors = [];

    const formula = editCustomEquipmentModal.equipmentRecord().formula?.trim();
    if (!formula) return;

    const linkedPointColumns = getCurrentLinkedPointColumns();

    // Check if a function is defined but there are no points
    if (linkedPointColumns.length === 0) {
      editCustomEquipmentModal.errors.push("You must define at least one point before setting a function.");
      return false;
    }

    const points = getFormulaPointsForColumns(linkedPointColumns, editCustomEquipmentModal.errors);
    if (!points) return false;


    try {
      // Ensure function is well-formed
      const testFunc = new Function(`return (${formula})`)();

      // Ensure it's actually a function
      if (typeof testFunc !== "function") {
        throw new Error("Formula must be a valid function.");
      }

      // Ensure it contains a return statement
      const functionString = testFunc.toString();
      if (!functionString.includes("return")) {
        throw new Error("Function must contain a 'return' statement.");
      }

      // Extract the number of parameters from the function
      const paramMatch = functionString.match(/\(([^)]*)\)/); // Extract parameters inside `()`
      const paramList = paramMatch ? paramMatch[1].split(',').map(p => p.trim()).filter(p => p) : [];
      const expectedParams = paramList.length;

      // Ensure the number of points matches the function parameters
      if (expectedParams !== points.length) {
        throw new Error(`Function expects ${expectedParams} parameters, but ${points.length} points are defined.`);
      }

      if (!points.every(p => p.hasOwnProperty('value'))) {
        throw new Error(`Not all points have value.`)
      }

      const result = evaluateFormula(formula, points.map(p => p.value));

      // Store the result
      editCustomEquipmentModal.equipmentRecord().formulaValue = result;

      return true; // No errors, function executed successfully
    } catch (err) {
      editCustomEquipmentModal.errors.push(`Invalid JavaScript function: ${err.message}`);
      return false; // Stop execution
    }
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title(record ? 'Edit ' + record['@class'] + ': ' : 'Create Equipment: ')
  modal.vm.body = editCustomEquipmentModal.view,
    modal.vm.buttons([
      {
        label: "Save",
        class: record ? "dib mr2 green" : "btn-good",
        func: submit
      }
    ]);

  record && options.delete ? modal.vm.buttons().unshift({
    label: record.parentClass == 'System' ? "Delete from System" : "Move to Recycle Bin",
    class: "dib mr2 red ",
    func: () => {
      if (record.parentClass == 'System') {
        loaders.requestWithLoader({
          loader: 'main',
          url: `/api/v1/hasEquipment/${record.linkKey.slice(1)}`,
          method: 'DELETE',
        })
          .then(function (response) {
            options && options.submitCallback ? options.submitCallback() : '';
            key.unbind('enter');
            modal.vm.close();
          })
      } else {
        let deleteEquipmentPromise = loaders.requestWithLoader({
          loader: 'main',
          url: `/api/v1/equipment/${record['@rid'].slice(1)}`,
          method: 'DELETE',
        })

        return deleteEquipmentPromise
          .then(function (response) {
            options && options.deleteCallback ? options.deleteCallback() : '';
            key.unbind('enter');
            modal.vm.close();
          })
      }

    }
  }) : null;

  modal.vm.open();
}

function arePortsNamesValid(portsData, errors) {
  let names = new Set(); // Set to store unique names
  for (let key in portsData) {
    if (portsData.hasOwnProperty(key)) {
      const port = portsData[key];
      const name = port.name;
      if (!name || name.trim() === '') {
        errors.push(`Ports names can't be blank.`);
        return false;
      }
      if (names.has(name)) {
        errors.push(`Ports should have unique names.`);
        return false; // Duplicate name found
      }
      if (!port.type) {
        errors.push('Port type is required.');
        return false;
      }
      if (!serviceTaxonomy.getServiceClass(port)) {
        errors.push('Port service class is required.');
        return false;
      }
      names.add(name);
    }
  }
  return true; // All names are unique
}

editCustomEquipmentModal.view = function () {
  editCustomEquipmentModal.portCenterSelected = prop(false);
  editCustomEquipmentModal.equipmentRecordPortValues.forEach(port => {
    if (port.position == 'center') {
      editCustomEquipmentModal.portCenterSelected(true);
    };
  });


  return m('form', { role: 'form' }, [
    editCustomEquipmentModal.errorView(),
    collapsibleSection({
      index: 0,
      title: 'Properties',
      isOpen: editCustomEquipmentModal.propertiesSectionOpen,
      toggle: () => {
        editCustomEquipmentModal.propertiesSectionOpen(!editCustomEquipmentModal.propertiesSectionOpen());
        m.redraw();
      },
      content: m('div', renderFields(
          Object.entries(editCustomEquipmentModal.fields).filter(([key, value]) => value.section === 'Properties').map(([key]) => key)
        ),
      )
    }),
    
    collapsibleSection({
      index: 1,
      title: 'Map',
      isOpen: editCustomEquipmentModal.mapSectionOpen,
      toggle: () => editCustomEquipmentModal.mapSectionOpen(!editCustomEquipmentModal.mapSectionOpen()),
      content: m('div', renderFields(
        Object.entries(editCustomEquipmentModal.fields).filter(([key, value]) => value.section === 'Map').map(([key]) => key)
      ))
    }),
    
    collapsibleSection({
      index: 2,
      title: 'Diagram',
      isOpen: editCustomEquipmentModal.diagramSectionOpen,
      toggle: () => editCustomEquipmentModal.diagramSectionOpen(!editCustomEquipmentModal.diagramSectionOpen()),
      content: m('div', renderFields(
        Object.entries(editCustomEquipmentModal.fields).filter(([key, value]) => value.section === 'Diagram').map(([key]) => key)
      ))
    }),

    collapsibleSection({
      index: 3,
      title: 'Ports',
      isOpen: editCustomEquipmentModal.portsSectionOpen,
      toggle: () => {
        editCustomEquipmentModal.portsSectionOpen(!editCustomEquipmentModal.portsSectionOpen());
        m.redraw();
      },
      content: m('div', renderPorts())
    }),
    
  ])

}

function addOptions(childrenArray, options, level) {
  level++;
  childrenArray.map(category => {
    options.push(m('option', { value: category.name }, `${'-'.repeat(level)} ${category.name}`));
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  })
}

function renderEquipmentClass() {
  return m('div.w-100.f3.pv2', [
    m('label', 'Equipment Class:'),
    m('select.form-control.mb2', {
      onchange: function (ev) {
        editCustomEquipmentModal.equipmentRecordClass(ev.target.value);
      },
      value: editCustomEquipmentModal.equipmentRecordClass()
    }, (() => {
      let options = [];
      let level = 0;
      equipmentModel.equipmentClassTree.categories.map(category => {
        options.push(m('option', { value: category.name }, `${'-'.repeat(level)} ${category.name}`));
        if (category.children && Array.isArray(category.children)) {
          addOptions(category.children, options, level);
        }
      });
      return options;
    })())
  ]);
}


// Simple collapsible UI block
function collapsibleSection({ title, isOpen, toggle, content, index }) {
  return m(`div.w-100.bw1.bb.pv2${index === 0 ? '.bt' : ''}`, [
    m('div.w-100.flex.justify-between.items-center', { onclick: toggle }, [
      m('p.f3.ma0', title),
      m(`i.f1.blue.ion-ios-arrow-${isOpen() ? 'up' : 'down'}`)
    ]),
    m('div.w-100.pt2.pb3', {
      style: {
        display: isOpen() ? 'block' : 'none'
      }
    }, content)
  ]);
}

// Renders the correct UI for each field type
function renderFields(keys) {
  const hideInDiagram = editCustomEquipmentModal.equipmentRecord().hideInDiagram;
  const animationType = editCustomEquipmentModal.equipmentRecord().animationType;


  return keys.map(key => {
    const value = editCustomEquipmentModal.fields[key];

    if (!value || value.hidden) return null;
    
    // Handle dynamic visibility based on animationType
    if (['svgBackground', 'svgForeground', 'rotatorDashArray', 'rotatorColor', 'hideAnimation', 'direction', 'svg'].includes(key)) {
      if (animationType === 'rotate') {
        if (key === 'svg') return null; // hide svg
      } else if (animationType === 'damper' || animationType === 'staticSvg') {
        if (key === 'svg') return null; // hide svg for damper/static
        if (['svgBackground', 'svgForeground', 'rotatorDashArray', 'rotatorColor', 'hideAnimation', 'direction'].includes(key)) {
          return null; // hide rotate-related extras
        }
      } else {
        // Not rotate, not damper/static → hide rotate extras, show only svg
        if (key !== 'svg') return null;
      }
    }

    if (key === 'hideLabel') return renderHideLabel();
    if (key === 'pointsLinked') {
      if (animationType === 'none') return null;
      return renderPointsLinked();
    }
    if (key === 'formula') {
      if (!['damper', 'rotate', 'staticSvg'].includes(animationType)) return null;
      return renderFormulaTest();
    }
    if (key === 'staticSvgs') return renderStaticSvgList();
    if (key === 'equipmentClass') return renderEquipmentClass();
    if (key === 'hideInDiagram') return renderHideInDiagram();
    if (key === 'hideDiagram') return renderHideDiagram();
    if (key === 'minValue') return null; // handled together below
    if (key === 'maxValue') {
      if (animationType === 'staticSvg' || animationType === 'none') return null;
      return renderMinMaxFields();
    }

    if (value.type === 'textarea') return renderTextarea(key);
    if (value.type === 'text') return renderText(key);
    if (value.type === 'select') return renderSelect(key);

    return null;
  });
}

function renderTextarea(key) {
  return [
    m('label', `${_.startCase(key)}:`),
    m('textarea.h4.mb2', {
      style: { resize: "none" },
      rows: 5,
      'box-sizing': 'border-box',
      oninput: (ev) => editCustomEquipmentModal.equipmentRecord()[key] = ev.target.value,
      value: editCustomEquipmentModal.equipmentRecord()[key],
      placeholder: `Add ${_.startCase(key)} here...`
    })
  ];
}

function renderText(key) {
  return [
    m('label', `${_.startCase(key)}:`),
    m('input.form-control.mb2', {
      type: 'text',
      oninput: (ev) => editCustomEquipmentModal.equipmentRecord()[key] = ev.target.value,
      value: editCustomEquipmentModal.equipmentRecord()[key],
    })
  ];
}

function renderSelect(key) {
  const value = editCustomEquipmentModal.fields[key];
  return [
    m('label', `${_.startCase(key)}:`),
    m('select.form-control.mb2', {
      onchange: (ev) => editCustomEquipmentModal.equipmentRecord()[key] = ev.target.value,
      oncreate: (vnode) => {
        vnode.dom.value = value.default;
      },
      value: editCustomEquipmentModal.equipmentRecord()[key],
    }, value.options.map(option => {
      return m('option', { value: option.value }, option.name)
    }))
  ];
}

// Custom renderer for pointsLinked + formula input
function renderPointsLinked() {
  const linkedPointColumns = getCurrentLinkedPointColumns();

  return [
    m('label', 'Points Linked'),
    m('div.w-100.pt2.pb3.cf', [
      linkedPointColumns.map((columnRecord, idx) => {
        if (! columnRecord) {
          columnRecord = {in: {}};
        }
        columnRecord.in.id = String.fromCharCode(65 + idx);
        return m('div.flex.items-center.mb1', [
          m('input.form-control.mr1', {
            style: { width: '20%' },
            type: 'text',
            oninput: ev => columnRecord.in['@rid'] = ev.target.value,
            value: columnRecord.in['@rid']
          }),
          m('div.mr1', { style: { width: '50%' } },
            columnRecord.in.missingResource
              ? m('div.red.f6', 'Linked point resource not found. Remove or relink this point.')
              : (columnRecord.in.path || []).map((ancestor, idx) =>
                  m('div.dib.mr1', `${ancestor.name}${idx < columnRecord.in.path.length - 1 ? ' /' : ''}`)
                )
          ),
          m('input.form-control.mr1', {
            style: { width: '10%' },
            type: 'text',
            value: columnRecord.in.id,
            disabled: true
          }),
          (()=> {
            if (columnRecord?.in['@rid'] && !columnRecord.in.missingResource) {
              return m('div.w-10.flex.justify-center.mr1', {
                style: { pointerEvents: 'none' }
              }, [
                m(pointTd, {
                  columnRecord: columnRecord,
                  textAlign: 'center',
                  options: { skipEditCheck: true, keepPollingOnModalOpen: true }
                })
              ])
            } else {
              return m('td')
            }
          })(),
          m(buttonElement, {
            class: 'w3 fr',
            label: m('i.f4.ion-ios-trash.red'),
            func: () => editCustomEquipmentModal.equipmentRecord().columns.splice(idx, 1)
          })
        ]);
      }),
      editCustomEquipmentModal.showFielnetTree() &&
      m('div', [
        m(fieldnetTree, { selectedPoint: editCustomEquipmentModal.newPointToAdd }),
        m('div.w-100.cf', {
          style: {
            visibility: editCustomEquipmentModal.newPointToAdd() ? 'visible' : 'hidden'
          }
        }, [
          m(buttonElement, {
            class: 'fr green mv2',
            label: [m('i.ion-plus.mr1'), 'Confirm Point'],
            func: async () => {
              let pointData = await loaders.requestWithLoader({
                loader: 'main',
                url: `/api/v1/point/${editCustomEquipmentModal.newPointToAdd().slice(1)}/resource`,
                method: 'GET'
              });
              editCustomEquipmentModal.equipmentRecord().columns.push({
                in: {
                  '@rid': editCustomEquipmentModal.newPointToAdd(),
                  id: editCustomEquipmentModal.newPointToAdd.id,
                  path: pointData.path
                }
              });
              editCustomEquipmentModal.showFielnetTree(false);
            }
          })
        ])
      ]),
      editCustomEquipmentModal.equipmentRecord().columns.length < 4 && !editCustomEquipmentModal.showFielnetTree() &&
      m(buttonElement, {
        class: 'fr blue mv2',
        label: [m('i.ion-plus.blue.mr1'), 'Add Point'],
        func: () => editCustomEquipmentModal.showFielnetTree(true)
      })
    ])
  ];
}

function renderStaticSvgList() {
  if (editCustomEquipmentModal.equipmentRecord().animationType !== 'staticSvg') return null;

  if (!Array.isArray(editCustomEquipmentModal.equipmentRecord().staticSvgs)) {
    editCustomEquipmentModal.equipmentRecord().staticSvgs = [];
  }

  const staticSvgs = editCustomEquipmentModal.equipmentRecord().staticSvgs;

  const listItems = staticSvgs.map((item, idx) => {
    const currentItem = item;
    if (typeof currentItem.svgConverted !== 'string') {
      currentItem.svgConverted = '';
    }

    const internalId = ensureStaticSvgInternalId(currentItem);
    const displayIndex = idx + 1;

    if (currentItem.key !== displayIndex) {
      currentItem.key = displayIndex;
    }

    return m('div.static-svg-item.ba.b--black-10.br2.pa3.mb3', {
      key: internalId,
      id: `static-svg-item-${internalId}`,
      'data-key': String(currentItem.key),
      'data-index': String(idx),
      'data-static-svg-uid': String(internalId)
    }, [
      m('div.flex.items-center.mb2', [
        m('span.static-svg-handle.dib.mr3.pointer.mid-gray', { title: 'Drag to reorder' }, [
          m('i.ion-navicon.blue.f4')
        ]),
        m('span.fw6.mr2', `#${displayIndex}`),
        m('input.form-control.flex-auto.mr2', {
          placeholder: 'Label (optional)',
          value: currentItem.label || '',
          oninput: (ev) => {
            currentItem.label = ev.target.value;
          }
        }),
        m(buttonElement, {
          class: 'w3',
          label: m('i.f4.ion-ios-trash.red'),
          func: () => {
            staticSvgs.splice(idx, 1);
            resequenceStaticSvgKeys(staticSvgs);
          }
        })
      ]),
      m('label.db.mb1.f6.mid-gray', 'SVG'),
      m('textarea.form-control.h4', {
        rows: 5,
        style: { resize: 'vertical' },
        value: currentItem.svg || '',
        oninput: (ev) => {
          currentItem.svg = ev.target.value;
          currentItem.svgConverted = '';
        }
      })
    ]);
  });

  const listContent = staticSvgs.length
    ? m(Sortable, {
        onsort: (orderNodes) => {
          const dragNodes = Array.from(orderNodes || []);
          if (!dragNodes.length) return;

          const currentOrder = staticSvgs.slice();
          const itemsByUid = new Map();
          currentOrder.forEach((entry) => {
            const uid = getStaticSvgInternalId(entry);
            if (Number.isFinite(uid)) {
              itemsByUid.set(String(uid), entry);
            }
          });

          if (!itemsByUid.size) return;

          const reordered = dragNodes
            .map((node) => {
              const dataset = node && node.dataset;
              if (!dataset) return null;
              const uidAttr = dataset.staticSvgUid;
              if (!uidAttr) return null;
              return itemsByUid.get(uidAttr) || null;
            })
            .filter(Boolean);

          if (reordered.length === currentOrder.length) {
            staticSvgs.splice(0, staticSvgs.length, ...reordered);
            resequenceStaticSvgKeys(staticSvgs);
            m.redraw();
          }
        },
        draggable: '.static-svg-item',
        handleClass: '.static-svg-handle',
        htmlElement: 'div'
      }, listItems)
    : m('div.ba.b--black-10.br2.pa3.tc', m('span.mid-gray', 'No static SVGs added yet.'));

  return [
    m('label', 'Static SVGs'),
    m('p.f6.mid-gray.mt0', 'Manage the set of SVGs to display when using the Static SVG animation.'),
    listContent,
    m('div.cf.mt2', [
      m(buttonElement, {
        class: 'fr blue',
        label: [m('i.ion-plus.blue.mr1'), 'Add SVG'],
        func: () => {
          const nextKey = editCustomEquipmentModal.nextStaticSvgKey++;
          const newItem = {
            key: nextKey,
            label: '',
            svg: '',
            svgConverted: ''
          };
          ensureStaticSvgInternalId(newItem);
          staticSvgs.push(newItem);
        }
      })
    ])
  ];
}

function renderFormulaTest() {
  return m('div.w-100.mb3', [
    m('label', 'Formula (JavaScript Code):'),
    m('textarea.form-control.h4.mb2', {
      style: { resize: 'none' },
      rows: 5,
      placeholder: 'Add JavaScript function here...',
      value: editCustomEquipmentModal.equipmentRecord().formula,
      oninput: (ev) => {
        editCustomEquipmentModal.equipmentRecord().formula = ev.target.value;
      },
    }),

    m('div.flex.justify-between', [
      m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.nowrap', {
        onclick: () => editCustomEquipmentModal.testFormula()
      }, 'Test Formula'),

      m('input.form-control', {
        type: 'text',
        value: editCustomEquipmentModal.equipmentRecord().formulaValue,
        readonly: true,
      })
    ])
  ]);
}

function renderHideLabel() {
  return m('div.mr1.w-100.mb2.flex.justify-between', [
    m('label', 'Hide Label'),
    m(ToggleSwitch, {
      id: 'check_hideLabel',
      checked: editCustomEquipmentModal.equipmentRecord().hideLabel === 'true',
      ariaLabel: 'Hide label',
      onchange: function (ev) {
        editCustomEquipmentModal.equipmentRecord().hideLabel = ev.target.checked ? 'true' : 'false';
      }
    })
  ]);
}

function renderHideInDiagram() {
  return m('div.mr1.w-100.mb2.flex.justify-between', [
    m('label', 'External Diagrams'),
    m(ToggleSwitch, {
      id: 'check_hideInDiagram',
      checked: editCustomEquipmentModal.equipmentRecord().hideInDiagram === 'true',
      ariaLabel: 'External diagrams',
      onchange: function (ev) {
        editCustomEquipmentModal.equipmentRecord().hideInDiagram = ev.target.checked ? 'true' : 'false';
      }
    })
  ]);
}

function renderHideDiagram() {
  return m('div.mr1.w-100.mb2.flex.justify-between', [
    m('label', 'Hide Diagram'),
    m(ToggleSwitch, {
      id: 'check_hideDiagram',
      checked: editCustomEquipmentModal.equipmentRecord().hideDiagram === 'true',
      ariaLabel: 'Hide diagram',
      onchange: function (ev) {
        editCustomEquipmentModal.equipmentRecord().hideDiagram = ev.target.checked ? 'true' : 'false';
      }
    })
  ]);
}

function renderMinMaxFields() {
  return m('div.flex.justify-between.mb2', [
    m('div.w-50.mr2', [
      m('label', 'Min Value:'),
      m('input.form-control', {
        type: 'text',
        value: editCustomEquipmentModal.equipmentRecord().minValue,
        oninput: (ev) => editCustomEquipmentModal.equipmentRecord().minValue = ev.target.value
      })
    ]),
    m('div.w-50', [
      m('label', 'Max Value:'),
      m('input.form-control', {
        type: 'text',
        value: editCustomEquipmentModal.equipmentRecord().maxValue,
        oninput: (ev) => editCustomEquipmentModal.equipmentRecord().maxValue = ev.target.value
      })
    ])
  ]);
}


function renderPorts() {
  return [
    m('div.flex.w-100.mb1', [
      m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '15%' } }, m('p.ma0.tc.truncate', 'Name')),
      m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '15%' } }, m('p.ma0.tc.truncate', 'External Position')),
      m('div.tc.v-btm.fw2.bw1.ph2.w-10', m('p.ma0.tc.truncate', 'Type')),
      m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '15%' } }, m('p.ma0.tc.truncate', 'Arrow Direction')),
      m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '15%' } }, m('p.ma0.tc.truncate', 'Arrow Connector')),
      m('div.tc.v-btm.fw2.bw1.ph2.w-20', m('p.ma0.tc.truncate', 'Class')),
      m('div.tc.v-btm.fw2.bw1.ph2.w-10')
    ]),

    editCustomEquipmentModal.equipmentRecordPortValues.map((port, idx) => {
      if (port.position === 'center') port.type = 'bidirectional';
      return m('div.flex.items-center.mb1', [
        m('div.mr1', { style: { width: '15%' } }, [
          m('input.form-control', {
            type: 'text',
            value: port.name,
            oninput: (ev) => port.name = ev.target.value
          })
        ]),
        m('div.mr1', { style: { width: '15%' } }, [
          m('select.form-control', {
            value: port.position,
            onchange: (ev) => {
              port.position = ev.target.value;
              port.type = normalizePortTypeForPosition(port.position, port.type);
              editCustomEquipmentModal.portCenterSelected(
                ev.target.value === 'center'
              );
            }
          }, [
            m('option', { value: 'center', disabled: editCustomEquipmentModal.portCenterSelected() && port.position !== 'center' }, 'Center'),
            m('option', { value: 'left' }, 'Left'),
            m('option', { value: 'right' }, 'Right'),
            m('option', { value: 'top' }, 'Top'),
            m('option', { value: 'bottom' }, 'Bottom')
          ])
        ]),
        m('div.w-10.mr1', [
          m('select.form-control', {
            value: normalizePortTypeForPosition(port.position, port.type),
            onchange: (ev) => port.type = ev.target.value
          }, [
            port.position === 'center'
              ? m('option', { value: 'bidirectional' }, 'Bidirectional')
              : [
                  m('option', { value: 'input' }, 'Input'),
                  m('option', { value: 'output' }, 'Output')
                ]
          ])
        ]),
        m('div.mr1', { style: { width: '15%' } }, [
          m('select.form-control', {
            value: port.direction,
            onchange: (ev) => port.direction = ev.target.value
          }, [
            m('option', { value: 'right' }, 'Right'),
            m('option', { value: 'left' }, 'Left')
          ])
        ]),
        m('div.mr1', { style: { width: '15%' } }, [
          m('select.form-control', {
            value: port.connector,
            onchange: (ev) => port.connector = ev.target.value
          }, [
            m('option', { value: 'head' }, 'Head'),
            m('option', { value: 'tail' }, 'Tail')
          ])
        ]),
        m('div.w-20.mr1', [
          m(serviceClassSelect, {
            class: 'form-control',
            value: serviceTaxonomy.getServiceClass(port),
            onchange: (value) => serviceTaxonomy.setServiceClass(port, value)
          })
        ]),
        m('div.w-10', [
          m(buttonElement, {
            class: 'w3 fr',
            label: m('i.f4.ion-ios-trash.red'),
            func: () => editCustomEquipmentModal.equipmentRecordPortValues.splice(idx, 1)
          })
        ])
      ]);
    }),

    m('div.flex.w-100.justify-between', [
      m(buttonElement, {
        class: 'fr blue',
        label: [m('i.ion-plus.blue.mr1'), 'Add Port'],
        func: () => {
          editCustomEquipmentModal.equipmentRecordPortValues.push(createDefaultPort(nextPortId(editCustomEquipmentModal.equipmentRecordPortValues)));
        }
      })
    ])
  ];
}

function findFirstServiceClass(categories) {
  for (let idx = 0; idx < (categories || []).length; idx++) {
    let category = categories[idx];
    if (!category) continue;
    if (category.name && category.name !== 'Overview') return category.name;
    let childClass = findFirstServiceClass(category.children || []);
    if (childClass) return childClass;
  }
  return '';
}

function getDefaultServiceClass() {
  return findFirstServiceClass((serviceModel.measurableClassTree || {}).categories || []);
}

function nextPortId(ports) {
  if (!ports || ports.length === 0) return 1;
  return ports.reduce(function (maxId, port) {
    var id = Number(port && port.id);
    return Number.isFinite(id) && id > maxId ? id : maxId;
  }, 0) + 1;
}

function normalizePortTypeForPosition(position, type) {
  if (position === 'center') return 'bidirectional';
  return type === 'input' || type === 'output' ? type : DEFAULT_PORT_TYPE;
}

function createDefaultPort(id) {
  var serviceClass = getDefaultServiceClass();
  return {
    name: '',
    id: id,
    position: DEFAULT_PORT_POSITION,
    type: DEFAULT_PORT_TYPE,
    direction: DEFAULT_PORT_DIRECTION,
    connector: DEFAULT_PORT_CONNECTOR,
    serviceClass: serviceClass,
    class: serviceClass
  };
}

editCustomEquipmentModal._private = {
  buildPointsLinkedPayload,
  createDefaultPort,
  createLinkedPointColumn,
  createMissingLinkedPointColumn,
  findFirstServiceClass,
  getFormulaPointsForColumns,
  getMissingLinkedPointColumns,
  nextPortId,
  normalizePortTypeForPosition,
  normalizeLinkedPointColumns,
  normalizeLinkedPointRid
};

module.exports = editCustomEquipmentModal;
